export default "__VITE_ASSET__CYvs6SEE__"